module.exports = {"150981005":"新城区街道","150981006":"旧城区街道","150981007":"北城区街道","150981008":"工业区街道","150981009":"南城区街道","150981107":"隆盛庄镇","150981108":"黑土台镇","150981109":"红砂坝镇","150981110":"巨宝庄镇","150981111":"三义泉镇","150981207":"浑源窑乡","150981208":"元山子乡","150981209":"官屯堡乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150981.json
// module id = 430
// module chunks = 0